import apiService from '@/services/ApiService'

export default {
    data() {
        return {
            appTag: '...',
            appVersion: '...',
            appVersionDate: '...',
        }
    },
    async created() {
        try {
            const v = await apiService.request('/status/version', { method: 'GET' })
            this.appTag = v.tag
            this.appVersion = v.hash
            this.appVersionDate = v.date
        } catch (e) {}
    }
}
